/**
 * Irrigation Activity Indicator Component
 * Displays current irrigation status with blinking animation when active
 */

const React = require('react');
const { useTranslation } = require('react-i18next');
const PropTypes = require('prop-types');
require('./IrrigationActivityIndicator.css');

/**
 * IrrigationActivityIndicator component
 * @param {Object} props
 * @param {boolean} props.isIrrigating - Whether irrigation is currently active
 * @param {string} props.displayText - Formatted time text
 * @param {string} props.source - Source of irrigation data
 */
const IrrigationActivityIndicator = ({ isIrrigating, displayText, source }) => {
  const { t } = useTranslation();
  if (!displayText || displayText === 'N/A') {
    return (
      <div className='irrigation-activity-indicator irrigation-activity-indicator--empty'>
        <span
          className='text-style-short-lables-14-regular'
          style={{ color: 'var(--color-grey-71)' }}
        >
          {t('no_data')}
        </span>
      </div>
    );
  }

  return (
    <div className='irrigation-activity-indicator'>
      {isIrrigating && (
        <div className='irrigation-activity-indicator__status'>
          <span className='irrigation-activity-indicator__dot irrigation-activity-indicator__dot--blinking' />
          <span className='text-style-short-lables-14-semi-bold irrigation-activity-indicator__text'>
            {t('irrigating')}
          </span>
        </div>
      )}
      <div className='irrigation-activity-indicator__time'>
        <span
          className='text-style-short-lables-14-regular'
          style={{ color: 'var(--color-grey-45)' }}
        >
          {displayText}
        </span>
      </div>
      {source && (
        <div className='irrigation-activity-indicator__source'>
          <span
            className='text-style-short-lables-12-regular'
            style={{ color: 'var(--color-grey-71)' }}
          >
            {source === 'flow_meter' && t('flow_meter_source')}
            {source === 'manual_input' && t('manual_input_source')}
            {source === 'connect_sensor' && t('connect_sensor_source')}
          </span>
        </div>
      )}
    </div>
  );
};

IrrigationActivityIndicator.propTypes = {
  isIrrigating: PropTypes.bool.isRequired,
  displayText: PropTypes.string.isRequired,
  source: PropTypes.oneOf([
    'flow_meter',
    'manual_input',
    'connect_sensor',
    'unknown',
  ]),
};

IrrigationActivityIndicator.defaultProps = {
  source: 'unknown',
};

module.exports = IrrigationActivityIndicator;
